import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { Database } from '../../server/database';
import { getAssetImage } from '../util/util';
import './Modal.css'
import './OpenPackModal.css'

interface OpenPackModalProps {
  open: boolean;
  assets: any[];
  onClose: Function;
}

class OpenPackModal extends React.Component<OpenPackModalProps, {}> {
  constructor(props:OpenPackModalProps) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.props.onClose();
  }

  render() {
    if(!this.props.open)
      return (<div></div>);

    let sortedAssets = [];
    for(let i = 0; i < this.props.assets.length; i++) {
      let asset = Database.getAsset(this.props.assets[i].id);
      sortedAssets.push({asset, quantity: this.props.assets[i].quantity});
    }

    sortedAssets.sort((a, b)=>{
      if(a.asset.category == 'banner' && b.asset.category != 'banner')
        return -1;
      else if(a.asset.category != 'banner' && b.asset.category == 'banner')
        return 1;

      if(a.asset.category == 'portrait' && b.asset.category != 'portrait')
        return -1;
      else if(a.asset.category != 'portrait' && b.asset.category == 'portrait')
        return 1;

      if(a.asset.name < b.asset.name)
        return -1;
      else if(a.asset.name > b.asset.name)
        return 1;

      return 0;
    })

    let assetDivs = [];
    for(let i = 0; i < sortedAssets.length; i++) {
      let asset = sortedAssets[i];
      let src = getAssetImage(asset.asset);

      let className = 'open-pack-modal-asset-image';
      if(asset.asset.category == 'banner') 
        className = 'open-pack-modal-banner-image'

      assetDivs.push(
        <div key={i} style={{position: 'relative'}}>
          <img className={className} src={src}></img>
          {asset.quantity > 1 && 
            <div className="open-pack-modal-asset-quantity">x{asset.quantity}</div>
          }
        </div>
      )
    }

    return (
      <div className="modal open">
        <div className="modal-content open-pack-modal-content">
          <button className="modal-close-button" onClick={this.onClose}>
            <BsFillXCircleFill />
          </button>
          <div className="open-pack-modal-header">Pack Reveal</div>
          <div className="open-pack-modal-asset-container">
            {assetDivs}
          </div>
          <button style={{marginTop: '15px'}} onClick={()=>this.props.onClose()}>Continue</button>
        </div>
      </div>
    )
  }
}

export default OpenPackModal;